// @flow

import { connect } from 'react-redux';
import { SearchResults } from '../../components/works';
import { searchByAuthor } from '../../services/search';
import './searchworks.scss';

function searchResultsSubTitle(searchParams) {
  const { firstName, lastName, workTitle } = searchParams;
  const searchSubtitle = [workTitle, lastName, firstName]
    .filter(v => v !== '')
    .join(' + ');
  return `(${searchSubtitle})`;
}

const mapState = ({ search }) => ({
  className: 'search-works',
  title: 'Results for:',
  subTitle: searchResultsSubTitle(search.searchParams),
  backLinkTo: '/search',
  backLinkText: 'Search',
  linkTo: '/searchwork',
});

const mapDispatch = {
  getWorks: searchByAuthor,
};

export default connect(
  mapState,
  mapDispatch,
)(SearchResults);
